
import superagent from "superagent";
import {authorize} from "../helper/authorize-token";
import {deep_copy} from "../../lib/js-utils";

const LOAD_PAYMENTS = "LOAD_PAYMENTS";
const CLEAR_PAYMENTS = "CLEAR_PAYMENTS";
const SET_LOADING = "SET_LOADING";

const loadPayments = () => {
  const path = "/api/dwolla/admin-payments";
  return (dispatch, getState) => {
    dispatch({
      type: SET_LOADING,
      loading: true,
    })
    dispatch({
      type: LOAD_PAYMENTS,
      payload: superagent
        .post(path)
        .use(authorize(getState())),
    })
  }
}

// username is for admin. Otherwise, caller's username is used
const uploadCustomerDocuments = (token, index, document_type, username) => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/upload-customer-document")
      .use(authorize(token))
      .send({ index, document_type, username})
      .then( () => {
        resolve();
      });
  })
}

const clearPayments = () => {
  return (dispatch) => {
    dispatch({
      type: CLEAR_PAYMENTS,
    })
  }
}

const adminLookupBalances = token => {
  return new Promise((resolve, reject) => {
    return superagent.agent()
      .post("/api/dwolla/admin-lookup-balances")
      .use(authorize(token))
      .then( () => {
        resolve();
      });
  })
}

const setLoading = (loading) => {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      loading,
    })
  }
}


const BLANK_STATE = {
  past: [],
  current: [],
  future: [],
  queued: [],
  future_missed: [],
  balance: [],
};

const adminPaymentsReducer = (state = BLANK_STATE, action) => {

  let response;
  let new_state = deep_copy(state);

  switch(action.type) {

    case CLEAR_PAYMENTS:
      new_state = BLANK_STATE;
      return new_state;
    case SET_LOADING:
      new_state.loading = action.loading;
      return new_state;
    case LOAD_PAYMENTS + "_FULFILLED":
      response = action.payload.body.data;
      new_state.queued = response.queued;
      new_state.past = response.past;
      new_state.current = response.current;
      new_state.future = response.future;
      new_state.future_missed = response.future_missed;
      new_state.balance = response.balance;
      new_state.timestamp = response.timestamp;
      new_state.loading = false;
      return new_state;

    default:
      return state;
  }
}

export { adminPaymentsReducer, loadPayments, setLoading, clearPayments,
  adminLookupBalances, uploadCustomerDocuments,
}
